import { createClient } from "contentful";
import { ILocationContentfulData, ILocationContentfulFields } from "./contentful.interface";

const contentfulClient = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID as string,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN as string,
});

export const getLocationDetails = async (locationName: string): Promise<ILocationContentfulData | null> => {
  const {
    items: [locationData],
  } = await contentfulClient.getEntries<ILocationContentfulFields>({
    "include": 2,
    "content_type": "locationData",
    "fields.name": locationName,
  });

  return locationData;
};

export default contentfulClient;
